/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../connect/v2/resources/error';
import '../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bitty": {
        "nested": {
          "GetOrCreateW9InfoRequest": {
            "fields": {}
          },
          "GetOrCreateW9InfoResponse": {
            "fields": {
              "w9Completed": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "prefillData": {
                "type": ".squareup.bitty.W9PrefillData",
                "id": 2,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "W9PrefillData": {
            "fields": {
              "individual": {
                "type": ".squareup.bitty.IndividualData",
                "id": 1
              },
              "business": {
                "type": ".squareup.bitty.BusinessData",
                "id": 2
              }
            },
            "nested": {
              "entity_data": {
                "oneof": ["individual", "business"]
              }
            }
          },
          "IndividualData": {
            "fields": {
              "legalName": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "legalAddress": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "BusinessData": {
            "fields": {
              "businessName": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "businessAddress": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "CompleteW9InfoRequest": {
            "fields": {
              "ssn": {
                "type": "string",
                "id": 1
              },
              "ein": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "tax_number": {
                "oneof": ["ssn", "ein"]
              }
            }
          },
          "CompleteW9InfoResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 1,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bitty?.nested?.GetOrCreateW9InfoRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.GetOrCreateW9InfoResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.W9PrefillData && !$root.nested?.squareup?.nested?.bitty?.nested?.IndividualData && !$root.nested?.squareup?.nested?.bitty?.nested?.BusinessData && !$root.nested?.squareup?.nested?.bitty?.nested?.CompleteW9InfoRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.CompleteW9InfoResponse) {
  $root.addJSON(jsonData);
}

/**
 * Request to get W9 information for a merchant
 *
 * SOURCE GetOrCreateW9InfoRequest @ squareup/bitty/w9.proto at 14:1
 */
export const GetOrCreateW9InfoRequest = $root.lookupType('squareup.bitty.GetOrCreateW9InfoRequest');
fixType(GetOrCreateW9InfoRequest);
Builder.createAndAttachToType(GetOrCreateW9InfoRequest);
/**
 * SOURCE GetOrCreateW9InfoResponse @ squareup/bitty/w9.proto at 18:1
 */
export const GetOrCreateW9InfoResponse = $root.lookupType('squareup.bitty.GetOrCreateW9InfoResponse');
fixType(GetOrCreateW9InfoResponse);
Builder.createAndAttachToType(GetOrCreateW9InfoResponse);
/**
 * Pre-fill data for W9 form from Legal Entities
 *
 * SOURCE W9PrefillData @ squareup/bitty/w9.proto at 28:1
 */
export const W9PrefillData = $root.lookupType('squareup.bitty.W9PrefillData');
fixType(W9PrefillData);
Builder.createAndAttachToType(W9PrefillData);
/**
 * Individual entity data for W9 form pre-fill
 *
 * SOURCE IndividualData @ squareup/bitty/w9.proto at 36:1
 */
export const IndividualData = $root.lookupType('squareup.bitty.IndividualData');
fixType(IndividualData);
Builder.createAndAttachToType(IndividualData);
/**
 * Business entity data for W9 form pre-fill
 *
 * SOURCE BusinessData @ squareup/bitty/w9.proto at 45:1
 */
export const BusinessData = $root.lookupType('squareup.bitty.BusinessData');
fixType(BusinessData);
Builder.createAndAttachToType(BusinessData);
/**
 * User "completes" w9 by validating their tax number
 * on the backend we update Taxman using the legal entity information
 *
 * SOURCE CompleteW9InfoRequest @ squareup/bitty/w9.proto at 54:1
 */
export const CompleteW9InfoRequest = $root.lookupType('squareup.bitty.CompleteW9InfoRequest');
fixType(CompleteW9InfoRequest);
Builder.createAndAttachToType(CompleteW9InfoRequest);
/**
 * No errors implies success
 *
 * SOURCE CompleteW9InfoResponse @ squareup/bitty/w9.proto at 63:1
 */
export const CompleteW9InfoResponse = $root.lookupType('squareup.bitty.CompleteW9InfoResponse');
fixType(CompleteW9InfoResponse);
Builder.createAndAttachToType(CompleteW9InfoResponse);